import { useQuery } from 'react-query'
import { useChosenCompany } from '../../../../context/UserProvider'
import { fetchPurhcaseExpenseReport } from '../../../../api/api'
import { useParams } from 'react-router-dom'
import PurchaseReportAccountDetailsTable from '../components/PurchaseTables/PurchaseReportAccountDetailsTable'
import type { PurchaseReportAccountDetails as PurchaseAccountDetails } from '../../../../types'

const PurchaseReportAccountDetails = () => {
  const { date, account } = useParams()
  const company = useChosenCompany()
  const companyId = company?.id

  const [year, month] = date ? date.split('-') : ['', '']

  const { data = [], isLoading } = useQuery(
    ['purchaseExpenseReport'],
    () =>
      fetchPurhcaseExpenseReport({
        year,
        month,
        account,
      }),
    { enabled: !!companyId },
  ) as { data: PurchaseAccountDetails[]; isLoading: boolean }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:items-center md:flex-row gap-2">
        <span className="text-xl font-medium text-primaryText">Kjøpsrapport</span>
        <span className=" hidden md:block text-lg text-secondaryText">/</span>
        <span className="text-lg text-secondaryText">
          {year}-{month}
        </span>
      </div>
      <PurchaseReportAccountDetailsTable isLoading={isLoading} data={data} />
    </div>
  )
}

export default PurchaseReportAccountDetails
